__turbopack_context__.v({
  "extraFast": "animation-module__PYG7nq__extraFast",
  "extraLarge": "animation-module__PYG7nq__extraLarge",
  "extraSlow": "animation-module__PYG7nq__extraSlow",
  "fadeIn": "animation-module__PYG7nq__fadeIn",
  "fadeOut": "animation-module__PYG7nq__fadeOut",
  "fast": "animation-module__PYG7nq__fast",
  "flip": "animation-module__PYG7nq__flip",
  "headShake": "animation-module__PYG7nq__headShake",
  "hintExpand": "animation-module__PYG7nq__hintExpand",
  "hop": "animation-module__PYG7nq__hop",
  "large": "animation-module__PYG7nq__large",
  "medium": "animation-module__PYG7nq__medium",
  "mediumSize": "animation-module__PYG7nq__mediumSize",
  "scalePulse": "animation-module__PYG7nq__scalePulse",
  "slideDown": "animation-module__PYG7nq__slideDown",
  "slideUp": "animation-module__PYG7nq__slideUp",
  "slow": "animation-module__PYG7nq__slow",
  "small": "animation-module__PYG7nq__small",
  "softGlow": "animation-module__PYG7nq__softGlow",
});
